export const en = {
  common: {
    'part-labels': {
      one: 'Part I.',
      two: 'Part II.',
      three: 'Part III.'
    },
    cgFirstName: 'CG First Name',
    cgLastName: 'CG Last Name',
    relation: 'Relation',
    riskLevel: 'Risk Level',
    startDate: 'Start Date',
    indicate: 'Indicate',
    interventionSchedule: 'Intervention Schedule',
    noBereavements: 'No bereavements were found for this patient.',
    other: 'Other',
    yes: 'Yes',
    submit: 'Submit',
    close: 'Close',
    no: 'No',
    kps: 'KPS',
    pps: 'PPS',
    na: 'N/A',
    loading: 'Loading',
    blank: ' ',
    nav: {
      chart: 'Chart',
      close: 'Close',
      logout: 'Logout',
      print: 'Print',
      facesheet: 'Facesheet'
    },
    patientId: 'Patient ID',
    dcCPP: "DC'd on",
    coveredNo: 'N',
    coveredYes: 'Y',
    on: {
      id: 'on',
      defaultMessage: 'on'
    },
    standingOrderInEffect: {
      id: 'standingOrderInEffect',
      defaultMessage: 'Standing Order in Effect from'
    },
    physician: {
      id: 'physician',
      defaultMessage: 'Physician'
    },
    createdBy: {
      id: 'createdBy',
      defaultMessage: 'Created by'
    },
    has: {
      id: 'has',
      defaultMessage: 'has'
    },
    have: {
      id: 'have',
      defaultMessage: 'have'
    },
    prnPerm: {
      id: 'prnPerm',
      defaultMessage: 'permission to make PRN visits without prior approval.'
    }
  }
  /* Override AG-Grid default translations below */
  // grid: {}

};
export default en;